module.exports = __webpack_public_path__ + "static/media/flag-poland.9cbc268d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/LanguageFlag/LanguageFlagIcons/flag-poland.svg
// module id = 1133
// module chunks = 1